export default __webpack_public_path__ + "static/media/e2-paneldiscussion.44f7c110.jpeg";